import React, { useState } from 'react';
import { Menu, X, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('authToken'));
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsLoggedIn(false);
    navigate('/');
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Services', path: '/#services' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Book Appointment', path: '/book' },
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">
              🧵 Endemik Solutions
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                className="text-gray-700 hover:text-teal-600 font-medium transition"
              >
                {link.name}
              </a>
            ))}
            
            {isLoggedIn && (
              <>
                <a
                  href="/admin"
                  className="text-gray-700 hover:text-teal-600 font-medium transition"
                >
                  Admin
                </a>
                <button
                  onClick={handleLogout}
                  className="flex items-center text-gray-700 hover:text-red-600 font-medium transition"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </button>
              </>
            )}

            {!isLoggedIn && (
              <a
                href="/admin"
                className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition font-medium"
              >
                Admin Login
              </a>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-gray-700">
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 space-y-2">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                className="block text-gray-700 hover:text-teal-600 font-medium py-2"
                onClick={() => setIsOpen(false)}
              >
                {link.name}
              </a>
            ))}
            
            {isLoggedIn && (
              <>
                <a
                  href="/admin"
                  className="block text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsOpen(false)}
                >
                  Admin Dashboard
                </a>
                <button
                  onClick={() => {
                    handleLogout();
                    setIsOpen(false);
                  }}
                  className="block w-full text-left text-gray-700 hover:text-red-600 font-medium py-2"
                >
                  Logout
                </button>
              </>
            )}

            {!isLoggedIn && (
              <a
                href="/admin"
                className="block bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-700 transition font-medium text-center"
                onClick={() => setIsOpen(false)}
              >
                Admin Login
              </a>
            )}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
